import { SignupPlan } from 'views/auth/signup/Plan';

export function ChangePlan() {
  return <SignupPlan isChangePlan />;
}
